import { api } from '$app/api';

export const getBookingsToAllocateToDrivers = async (startDate) => {
  const { data } = await api.post('/allocations/drivers/bookings', {
    startDate,
  });
  return data;
};
